export const constJs = {
    passPdf: '^456456TYRGY&%^**^&*4',
    pathPid:'feh5y5654F$6456ut98w~#$#$^',
    map:'tret57b89Y78%$^%$&EF654'
}


// WEBPACK FOOTER //
// ./src/js/constJs.js